import * as discountCodeHelper from '../../helpers/discount_codes';

export function calculateTotalPrice (lineItem) {
    const { price } = lineItem;
    return (lineItem.quantity * price.price)
}

export function formatLocationAddress (locationAddress, customer, phone) {
    return locationAddress
        ? {
            id: locationAddress.first_name ?? customer.additional_data.first_name,
        }
        : null;
}

export function getDiscountDetails (lineItem) {
    const { price } = lineItem;
    const unitPrice = price.price_list
        ? price.original
        : price.unit;

    const total = parseFloat(price.total) - parseFloat(lineItem.discount_code?.total || '0');
    const value = (lineItem.quantity * unitPrice) - total;

    // we have to round it, otherwise JS will do some weird stuff with it
    const noChange = (parseFloat(value.toFixed(2)) == 0)

    return (noChange)
        ? null
        : {
            valueType: 'FIXED_AMOUNT',
            value: Number((value / lineItem.quantity).toFixed(2)),
        };
}

export function applyDiscountCode (lineItems, discountCode) {
    const eligibleList = discountCodeHelper.itemsToEligibleList(discountCode);

    const originalSortOrder = lineItems.map(item => item.id);
    const sortedByPrice = [...lineItems].sort(
        (left, right) => parseFloat(left.price.discounted) - parseFloat(right.price.discounted)
    );

    const updatedLineItems = sortedByPrice.map(item => {
        const code = eligibleList[item.shopify_product_id] || {
            eligible: false,
        };

        item.discount_code = null;

        const quantity = parseInt(item.quantity, 10);

        if (item.price.manual || ! code.eligible || ! quantity) {
            return item;
        }

        const unitPrice = parseFloat(item.price.discounted);

        if (code.eligible_amount === -1) {
            return {
                ...item,
                discount_code: {
                    amount: -1,
                    total: discountCodeHelper.calculateTotalPrice(discountCode, unitPrice, quantity)
                        .toFixed(2)
                }
            };
        }

        // free_other_collection require to keep the origin_collection.quantity items
        // without the discount
        // we have to include that in the calculation of the available items we can discount
        const availableQty = ('origin_products' in code && code.origin_products.includes(`${item.shopify_product_id}`))
            ? Math.max(code.origin_qty - code.required_qty, 0)
            : quantity;

        const eligibleAmount = Math.min(code.eligible_amount, availableQty);

        item.discount_code = {
            amount: eligibleAmount,
            total: discountCodeHelper.calculateTotalPrice(discountCode, unitPrice, eligibleAmount)
                .toFixed(2)
        }

        code.eligible_amount -= eligibleAmount;

        // We're running in a loop
        // if the origin_qty is defined, we have to lower it by the number of discounted items
        // this will ensure that the other eligible origin items are not discounted
        if ('origin_qty' in code) {
            code.origin_qty -= eligibleAmount;
        }

        return item;
    });

    return {
        lineItems: updatedLineItems.sort(
            (left, right) => originalSortOrder.indexOf(left.id) - originalSortOrder.indexOf(right.id)
        ),
        discountCode,
    }
}
